module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_5012.a95c300f.png";